//CSS ENTRY POINT
//import '../scss/main.scss';
//=====================================
//jquery
// import $ from 'jquery';
// window.$ = $;
// window.jQuery = $;
//=====================================
window.$ = window.jQuery = require('jquery');
global.$ = global.jQuery = require('jquery');
//=====================================
// Popper
// require('@popperjs/core');
// require('bootstrap');
// import * as Popper from "@popperjs/core"
//=====================================
window.Popper = require('@popperjs/core');

//=====================================
//Bootstrap
//import * as bootstrap from 'bootstrap';
// // Or import only needed plugins
// import { Tooltip as Tooltip, Toast as Toast, Popover as Popover } from 'bootstrap';
// // Or import just one
// import Alert as Alert from '../node_modules/bootstrap/js/dist/alert';
//=====================================
// require('bootstrap');

//=====================================
//LIGHT BOX2
//=====================================
const Lightbox = require('bs5-Lightbox').default;
window.Lightbox = Lightbox;

//=====================================
//Gsap
//=====================================
import { gsap } from "gsap/dist/gsap";
// import { CSSPlugin } from "gsap/CSSPlugin";
import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
import { ScrollToPlugin } from "gsap/dist/ScrollToPlugin";
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

//=====================================
//SplitType
//=====================================
const SplitType = require('split-type').default;
window.SplitType = SplitType;
//=====================================
//Swiper
// import Swiper JS
// Swiper, Keyboard, Navigation, Pagination, Controller, History, Autoplay, EffectFade, EffectCube, EffectFlip, EffectCoverflow, Lazy, A11y
//=====================================
const Swiper = require('swiper/bundle').default;
const { Navigation, Pagination, Autoplay, EffectFade } = Swiper;
Swiper.use([Navigation, Pagination, Autoplay, EffectFade]);
window.Swiper = Swiper;

//////////////////////
//TEXTAREAの高さを調整
//////////////////////
$.fn.AutoHeight = function() {
    function autoHeight_(element) {
    return $(element).css({
        'height': '1.8rem',
        'overflow-y': 'hidden'
    }).height(element.scrollHeight);
    }
    return this.each(function () {
    autoHeight_(this).on('input', function () {
    autoHeight_(this);
    });
    });
}

//////////////////////
//Scrollに関するエラー
//////////////////////
// lazyload();
// function simulateSlowLoad() {
//   setTimeout(function() {
//     $('body').addClass('loaded');
//     $('#loader').addClass('hide');
//   }, 500);
// }
// // ページがロードされたときに遅延を開始する
// window.addEventListener("load", function() {
//   simulateSlowLoad();
// });


$(function(){
/////////////////////////////////////
/// SIDEBAR表示トリガー
/////////////////////////////////////
$('.sidebar-toggle').on('click', function() {
  $('body').toggleClass('is-pc-sidemenu');
})
$(document).on("click", function(event) {
  if (!$(event.target).closest("#sidebar").length && !$(event.target).is(".sidebar-toggle")) {
    $('body').removeClass('is-pc-sidemenu');
  }
});
//////////////////////
//SIDE NAV (APP)
//////////////////////
$("#nav-app").on({
  "mouseenter click":function(){
    $(this).addClass("is_slidein");
  },
  "mouseleave":function(){
    $(this).removeClass("is_slidein");
  },
 });

//////////////////////
//スクロース中はSIDE NAVを隠す挙動
//////////////////////
var timeoutId ;
var count = 0 ;
window.addEventListener( "scroll", function () {
  clearTimeout( timeoutId ) ;
  $("#side-slide-navi").removeClass("is_scrollstop");
  timeoutId = setTimeout( function () {
    ++count ;
    
    if ($(window).scrollTop() >= 200){//headerの高さを超えたら
    $("#side-slide-navi").addClass("is_scrollstop");
    }
  }, 300 ) ;
  } ) ;

//別の要素をクリックで閉じる
$(document).on('click touchend',function(e) {
  if (!$(e.target).closest('#nav-app').length) {
    $("#nav-app").removeClass("is_slidein");
  }
});

//////////////////////
//SP BUGER MENU
//////////////////////
$('#global_burgermenu > button').on('click', function() {
  $(this).toggleClass('active');
  if($(this).hasClass('active')){
      $('body').addClass('is-sp-menu');
      $('body').removeClass('rm-sp-menu');
  }else{
      $('body').removeClass('is-sp-menu');
      $('body').addClass('rm-sp-menu');
  }
  return false;
});

$("#global-sp-menu").on("click",function(){
  $('#global_burgermenu > button').trigger('click');
})

$(document).on('click', function(event) {
  if ($('body').hasClass('is-sp-menu') && !$(event.target).closest("#global-sp-menu").length) {
    $('#global_burgermenu > button').trigger('click');
  }
});

// $("#global-sp-menu").on("click",function(){
//   $('#global_burgermenu > button').trigger('click');
// })

//////////////////////
//PRODUCT MENU DROP DOWN
//////////////////////
// $(".product-menu li").on({
//   "click": function(e) {
//     e.preventDefault();
//     var dropDown = $(this).find('.drop-down');
//     if (dropDown.length > 0 && dropDown.is(':hidden')) {
//       $(".drop-down:not(:animated)").slideUp(300);
//       $(".acc").removeClass("animate");
//       $("a").css("color", "");
//       dropDown.slideDown(300);
//       $(this).find(".acc").addClass("animate");
//       $(this).children("a").css("color", "#FFF");
//     } else if (dropDown.length === 0) {
//       window.location = $(this).find("a").attr("href"); // リンクを直接開く
//     } else {
//       dropDown.slideUp(300);
//       $(this).find(".acc").removeClass("animate");
//       $(this).children("a").css("color", "");
//     }
//   },
//   "mouseleave": function() {
//     $(this).find(".drop-down").slideUp(300);
//     $(this).find(".acc").removeClass("animate");
//     $(this).children("a").css("color", "");
//   },
// });

//////////////////////
//Scrollアニメーション SERVICE MENU
//////////////////////
$(window).scroll(function() {
  var serviceOffset = $('body').offset().top;
  var scrollPosition = $(window).scrollTop();
  if (scrollPosition > serviceOffset) {
      $('#side-menu-service').addClass('acc-fixed');
  } else {
      $('#side-menu-service').removeClass('acc-fixed');
  }
});


//////////////////////
//Scrollアニメーション
//////////////////////
  // // URLのハッシュを評価してスクロールアニメーションを実行
  // if (window.location.hash) {
  //   var target = $(window.location.hash);
  //   if (target.length) {
  //     $('html, body').animate({
  //       scrollTop: target.offset().top - 65
  //     }, 1000);
  //   }
  // }
  // //  // #で始まるアンカーリンクがクリックされたときに実行される処理
  //  $('a[href^="#"]').on('click', function(e) {

  //   e.preventDefault();
  //   getScroll
  //   var target = $(this).attr('href');
  //   var position = $(target).offset().top - 65;
  //   $('html, body').animate({ scrollTop: position }, 500);
  // });



//////////////////////
//SCROLL ANIMTAION
//////////////////////
 // URLのハッシュが存在するかチェック
  if (window.location.hash) {
    var targetId = window.location.hash.substring(1);
    var targetElement = $('#' + targetId);
    if (targetElement.length > 0) {
      targetElement.click();
      setTimeout(function() {
        var targetOffset = targetElement.offset().top;
        var bodyOffset = $('body').scrollTop();
        var scrollTo = targetOffset - bodyOffset;
        $('html, body').animate({
          scrollTop: scrollTo
        }, 500);  // スクロール時間（ミリ秒）
      }, 500);  // 適宜調整した遅延時間
    }
  }
  
   //URLのハッシュを削除
  $(window).on('scroll', function() {
    clearTimeout(window.scrollTimeout);
    window.scrollTimeout = setTimeout(function() {
      if (window.location.hash !== '') {
        history.replaceState(null, null, ' '); // ハッシュを削除
      }
    }, 500);  // スクロール停止後150ミリ秒後に実行
  });
  





/* ==================
SCROLL HEADER HEIGHT
===================== */
  var headerH = $("#header").outerHeight(true);//headerの高さを取得    
  function FixedAnime() {
    var scroll = $(window).scrollTop();
    if (scroll >= headerH){//headerの高さを超えたら
          $('body').addClass('is_scroll');
    }else{
          $('#body').removeClass('is_scroll');
    }    
  }
  
  // 画面をスクロールをしたら動かしたい場合の記述
  $(window).scroll(function () {
    FixedAnime();//スクロール途中からヘッダーの高さを変化させる関数を呼ぶ
  });
  
  // ページが読み込まれたらすぐに動かしたい場合の記述
  $(window).on('load', function () {
    FixedAnime();//スクロール途中からヘッダーの高さを変化させる関数を呼ぶ
  });



//////////////////////////////////
  /*右から移動*/
  gsap.utils.toArray('.am-x-r').forEach( (elm, index) => {
    gsap.from(elm,
      { x: 100,
        autoAlpha: 0 ,
        duration:1.5,
        opacity: 0,
        ease: "power2.out",
       scrollTrigger: {
        trigger: elm,
        start: 'top bottom', 
        end: 'bottom bottom',
        scrub: 1,
        // markers: true
        },
      });
  });
  
    
    /*左から移動*/
  gsap.utils.toArray('.am-x-l').forEach( (elm, index) => {
    gsap.from(elm,
      { x: -100,
        autoAlpha: 0 ,
        duration:1.5,
        opacity: 1,
        ease: "power2.out",
       stagger: 1.02,
       scrollTrigger: {
        trigger: elm,
        start: 'top bottom', 
        end: 'bottom bottom',
        scrub: 1,
        // markers: true
        },
      });
  });
    
    /*上から移動*/
  gsap.utils.toArray('.am-y-t').forEach( (elm, index) => {
    gsap.from(elm,
      { y: -100,
        autoAlpha: 0 ,
       duration:1.5,
        opacity: 1,
        ease: "power2.out",
        stagger:{
          from: "start", //左から
          amount: 0.8 // 0.8秒おき
        },
        scrollTrigger: {
          trigger: elm,
          start: 'top bottom', 
          end: 'bottom bottom',
          scrub: 1,
          // markers: true
          },
      });
  });
    /*下から移動*/
  gsap.utils.toArray('.am-y-b').forEach( (elm, index) => {
    gsap.from(elm,
     { y: 100,
        autoAlpha: 0 ,
       duration:1.5,
        opacity: 1,
        ease: "power2.out",
        stagger:{
          each:.5,
          ease: "power4.out",
          from: "start", //左から
          amount: 3.8 // 0.8秒おき
        },
        scrollTrigger: {
          trigger: elm,
          start: 'top bottom', 
          end: 'bottom bottom',
          scrub: 1,
          // markers: true
          },
      });
    });
  
  
  /*中央からスケール*/
  gsap.utils.toArray('.am-s-0').forEach( (elm, index) => {
  gsap.from(elm,
    { scaleX: .5,
      duration:1.5,
      opacity: 0,
      ease: "power2.out",
      scrollTrigger: {
        trigger: elm,
        start: 'top bottom', 
        end: 'bottom bottom',
        scrub: 1,
        // markers: true
        },
    });
  });
  
    /*ITEM 左から移動　2023/05/29表示が遅いので無効にした*/
    // gsap.utils.toArray('.item-01 > *').forEach( (elm, index) => {
    // gsap.from(elm,
    //   { x: -150,
    //     autoAlpha: 0,
    //     duration:.5,
    //     opacity: 0,
    //     ease: "power2.out",
    //     delay: index * 0.1, // 遅延
    //     scrollTrigger: {
    //     trigger: elm,
    //     start: 'top bottom', //start: 'top bottom-=250',もう少し遅めにスタートする場合
    //     end: 'bottom bottom',
    //     // markers: true
    //     },
    //     });
    // });


/////////////////////////////////
    /*画像パララックス*/
/////////////////////////////////
      gsap.utils.toArray('.am-y-plx').forEach( (elm, index) => {
      gsap.to(elm,{
        y: -100,
        ease: "none",
        scrollTrigger: {
          trigger: elm,
          start: 'top bottom',
          end: 'bottom top',
          scrub: 1,
          //markers: true
        },
      });
  });

//TOP PAGE MV
    // gsap.from("#an-tit", {
    //   y:0,
    //   scale:10,
    //   opacity: 0,
    //   rotation: -40,
    //   delay: 1,
    //   duration: .4,
    //   ease: "power2.out",
    // });

    // gsap.from("#an-stit", {
    //     x:-1000,
    //     y: -1000,
    //   rotation: -240,
    //   opacity: 0,
    //   delay: 1,
    //   duration: 1,
    //   scale:20,
      
    //   ease: "power2.out",
    // });

    // gsap.from(".an-typewrite .char", {
    //   y:-500,
    //   x:-500,
    //   opacity: 0,
    //   delay: 1.2,
    //   duration: 0.5,
    //   stagger:{
    //     each:.1,
    //     // ease: "power4.out",
    //     from: "start", //左から
    //     amount: .8, // 0.8秒おき
    //     scrub: 1,
    //   },
    //   // ease: "power2.out",
    // });

  // gsap.utils.toArray('#zzz2 .zzz').forEach( (zzz, index) => {
  //     gsap.fromTo(zzz,1,
  //       {x:-2000,
  //         rotation: 120,
  //         scale: 100,
  //         autoAlpha: 0 },
  //       {x:0,
  //         rotation: 0,
  //         scale:1,
  //         autoAlpha: 1,
  //         duration:1,
  //         scrollTrigger: {
  //         trigger: '#zzz2', //scrub: 1 // markers: true
  //         start: 'top bottom', 
  //         end: 'bottom bottom',
  //         //   scrub: 3,
  //         },
  //       }
  //     );
  // });
  
  

  // const tags = $('.mv-tags li');
  // tags.each(function(index, tag) {
  //   gsap.set(tag, {transformOrigin: "50% 50%"});
  //   $(tag).mouseenter(function() {
  //     gsap.to(tag, {duration: 0.5, scale: 2, rotation: gsap.utils.random(-20, 20)});
  //   });
  //   $(tag).mouseleave(function() {
  //     gsap.to(tag, {duration: 0.5, scale: 1, rotation: 0});
  //   });
  // });


  // TOP PAGE MV
  gsap.from("#an-tit_1", {
     x:  1500,
    y: 1500,
    scale: 10,
    opacity: 0,
    rotation: 100,
    delay: 0,
    duration: 1,
    ease: "power2.out"
  });
  gsap.from("#an-tit_2", {
    x: 1500,
    y: 1500,
    scale:10,
    opacity: 0,
    rotation:100,
    delay: .5,
    duration: 1,
    ease: "power2.out"
  });

  gsap.from("#an-stit .char", {
    x: 0,
    y: 10,
    stagger: .05,
    opacity: 0,
    delay: 1,
    duration: .1,
    ease: "power2.out"
  });

  gsap.from("#mv-txt00 .lst-glb-00 li", {
    //  y: 20,
    x: -130,
    stagger: .2,
    opacity: 0,
    delay: 1.5,
    duration: .4,
    ease: "power2.out"
  });


  gsap.from("#mv-txt02 li a", {
    x: 500,
    y: 0,
    stagger: .1,
    opacity: 0,
    rotation: 300,
    delay: 2,
    scale: 0,
    duration: .5,
    ease: "power2.out"
  });



//   // box-article mv
//   const mvImgElements = $('.box-article');
//   mvImgElements.each(function(index, mvImgElement) {
//     const boxElement = $(mvImgElement).find('.tit-txt');
//     gsap.from(boxElement, {
//       y: -100,
//       scale: 2.2,
//       rotation: -12,
//       scrollTrigger: {
//         trigger: mvImgElement,
//         start: 'top bottom',
//         end: 'bottom bottom',
//         // scrub: true
//       }
//     });
//     // gsap.to(boxElement2, {
//     //   x: 50,
//     //   y: 300,
//     //   scale: 1.8,
//     //   rotation: -12,
//     //   scrollTrigger: {
//     //     trigger: mvImgElement,
//     //     start: 'top+=180px top',
//     //     end: 'bottom top',
//     //     scrub: true
//     //   }
//     // });
//   });

// });


  /*右から移動*/
  $('.tit-txt').each(function(index, elm) {
    gsap.from(elm, {
      y: -100,
      scale:3,
      rotation:-10,
      // autoAlpha: 0,
      duration: .5,
      opacity: 1,
      ease: "power2.out",
      stagger: {
        from: "start",
        amount: 0.2
      },
      scrollTrigger: {
        trigger: elm,
        start: 'top-=100px bottom', // 開始位置を早めに
        end: 'bottom-=100px top',   // 最終位置を早めに停止
        scrub: 1
      }
    });
  });



  });
